<database-resource-menu></database-resource-menu>

<hr>

<div class="alert alert-warning alert-dismissible fade show" role="alert"
  *ngIf="_resourceService.alert">
  {{ _resourceService.alert | translate }}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"
    (click)="_resourceService.alert = null">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<loading-component *ngIf="_databaseResourcesService.loading"></loading-component>

<div *ngIf="!_databaseResourcesService.loading">

  <div class="d-flex justify-content-end">
    <button class="btn btn-main-color btn-sm  cursor-hand" data-toggle="modal" data-toggle="modal"
      data-target="#payorModal" (click)="action = 'create'"
      *ngIf="!_databaseResourcesService.RESOURCES_ON_SYNC">
      {{ 'ADD_NEW' | translate }}
    </button>
    <button class="btn btn-main-color btn-sm cursor-hand" (click)="sync()"
      *ngIf="_databaseResourcesService.RESOURCES_ON_SYNC">
      {{ 'SYNC' | translate }}
    </button>
  </div>



  <div class="card sm-12 margin-top-5"
    [ngClass]="payor.actived ? 'btn-main-color' : 'btn-secondary-color'"
    *ngFor="let payor of _databaseResourcesService.payors">
    <div class="card-header text-row-background-color-white">
      <div class="row">
        <div class="col-7">
          {{payor.id}} - {{payor.name}}
          <span *ngIf="!payor.actived"> - ({{ 'INACTIVE' | translate }})</span>
        </div>
        <div class="col-3 text-left tex-element-bold">
        </div>

        <div class="col-2 text-right">
          <div ngbDropdown class="d-inline-block">
            <i class="fas fa-pencil-alt cursor-hand" aria-hidden="true" data-toggle="modal"
              data-target="#payorModal" (click)="editPayor(payor)" [title]="'EDIT' | translate"></i>
            |
            <i class="fas fa-trash-alt cursor-hand" aria-hidden="true"
              *ngIf="!_databaseResourcesService.RESOURCES_ON_SYNC" (click)="deletePayor(payor)"
              [title]="'DELETE' | translate"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>






<!-- Payor Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" data-backdrop="static"
  data-keyboard="false" id="payorModal" tabindex="-1" role="dialog" aria-labelledby="payorModal"
  aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header btn-main-color">
        <div *ngIf="action == 'update'">{{ 'EDIT_PAYOR' | translate}}</div>
        <div *ngIf="action == 'create'">{{ 'NEW_PAYOR' | translate}}</div>
        <h5 class="modal-title" id="payorModal"></h5>
        <button type="button" class="close" data-dismiss="modal" (click)="cancelEdit()"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <div class="alert alert-warning alert-dismissible fade show" role="alert"
          *ngIf="_resourceService.alert">
          {{ _resourceService.alert | translate }}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"
            (click)="_resourceService.alert = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <form>

          <div class="form-group row">
            <label for="id" class="col-sm-3 col-form-label">{{ 'ID' | translate}} *</label>
            <div class="col-sm-9">
              <input class="form-control" required type="text" [value]="payor.id" name="id"
                [(ngModel)]=payor.id [disabled]="action == 'update'" maxlength="10">
            </div>
          </div>
          <div class="form-group row">
            <label for="name" class="col-sm-3 col-form-label">{{ 'NAME' | translate}}
              *</label>
            <div class="col-sm-9">
              <input class="form-control" required type="text" [value]="payor.name" name="name"
                [disabled]="_databaseResourcesService.RESOURCES_ON_SYNC" [(ngModel)]=payor.name>
            </div>
          </div>
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="actived" [value]="payor.actived"
                name="actived" [(ngModel)]=payor.actived>
              <label class="form-check-label" for="actived">{{ 'ACTIVED' | translate}}</label>
            </div>
          </div>



          <div class="form-group row mt-4">
            <div class="form-group col-md-6" *ngIf="action == 'create'">
              <button type="submit" class="btn btn-main-color btn-block" (click)="addPayor()">
                {{ 'CREATE' | translate}}
              </button>
            </div>
            <div class="form-group col-md-6" *ngIf="action == 'update'">
              <button type=" submit" class="btn btn-main-color btn-block" (click)="updatePayor()">
                {{ 'UPDATE' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal"
                (click)="cancelEdit()">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
&nbsp;